<!--
 * @Author: weiShu
 * @Date: 2025-12-29 15:40:44
 * @LastEditors: weiShu
 * @LastEditTime: 2025-12-30 08:32:41
 * @FilePath: \health-commission-new\src\components\tabbar.vue
 * @Description: 
-->
<template>
    <div class="wrapper tabbar-main">
        <div class="main-router">
            <router-view v-if="!$route.meta.keepAlive"/>
        </div>
        <van-row class="tabbar" type="flex" justify="space-between">
            <van-col span="4" class="item-tabbar" v-for="(item,index) in tabbarList" @click="tabClick(item,index)" :key='index'>
                <img :src="navIndex == (index+1) ? item.iconOn : item.iconDef" alt="">
                <span :class="navIndex == (index+1) ? 'active' : '' ">{{item.name}}</span>
                <span v-if="navIndex == (index+1)" class="nav-line"></span>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    components: {},
    props: {},
    data() {
        return {
            activeIndex: 1,
            tabbarList: [
                {name: '测评考试', nameUrl: 'evaluation', iconDef: require('@/assets/image/icon_tabnav_01_def.png'), iconOn: require('@/assets/image/icon_tabnav_01_on.png')},
                {name: '我的', nameUrl: 'my', iconDef: require('@/assets/image/icon_tabnav_02_def.png'), iconOn: require('@/assets/image/icon_tabnav_02_on.png')},
            ]
        };
    },
    watch: {},
    computed: {
        ...mapState(['navIndex'])
    },
    created() {},
    mounted() {
        //console.log(this.navIndex)
    },
    methods: {
        tabClick(item,index){
            console.log(item,index)
            // 其他标签直接跳转
            this.navigateToPage(item, index);
        },
        navigateToPage(item, index) {
            this.$store.commit('getNavIndex',index+1)
            this.$router.push({name: item.nameUrl})
        }
    },
    // activated(){
    //     console.log(this.$route)
    // },
};
</script>
<style scoped>
.tabbar-main{
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 60px;
}
.main-router{
    height: 100%;
}
.tabbar{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    z-index: 111;
    background: #fff;
}
.item-tabbar{
    position: relative;
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.item-tabbar img{
    width: 22px;
    height: 22px;
}
.item-tabbar span{
    margin-top: 4px;
    font-size: 12px;
    color: #333333;
}
.item-tabbar .active{
    color: #FF6633;
}
.item-tabbar .nav-line{
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 50px;
    height: 2px;
    margin-left: -25px;
    background: #FF6633;
}
</style>